// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_o6-5";
export var filledCircle = "_o6-4";
export var historyEntry = "_o6-3";
export var messageSideLeft = "_o6-1";
export var messageSideRight = "_o6-2";
export var orderTrackingCarouselWrapper = "_o6-6";
export var orderTrackingInfoContainer = "_o6-0";